<div class="py-3 px-2 w-100">
  <!-- HEADER -->
  <div class="d-flex align-items-center justify-content-between">
    <h1 class="mb-0">Complete Transaction</h1>
    <div class="flex-fill"></div>
    <button mat-icon-button (click)="cancel()" data-test="tx-complete-transaction-cancel-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- BODY -->
  @if (completeForm) {
    <div>
      <p class="d-block w-100 mb-1">
        Please enter the amount you wish process, payment will use original cardholder details.
      </p>
      <p class="d-block w-100 mb-4 text-muted">The maximum amount that can be completed is {{ maxCompletionAmount | currency: data.transaction.currencyCountry }}</p>
      <div>
        <odin-dynamic-form [formData]="completeForm"></odin-dynamic-form>
      </div>
    </div>
  }

  <odin-loading-spinner
    [active]="processing"
    [overlay]="true"
  ></odin-loading-spinner>
</div>
